/*
 * Журнал сетевых запросов для страницы «Сетевые логи» и консоли.
 *
 * В ПАМЯТИ ВКЛАДКИ, А НЕ В `localStorage` (с 29.09.2026). Раньше каждая запись
 * читала из `localStorage` до 500 прошлых — вместе с телами ответов, — дописывала
 * себя и сериализовала всё обратно. На проде журнал разросся до 4,6 МБ из ~5 МБ
 * квоты: каждый запрос гонял через JSON 4,6 МБ (на «Здравоохранении» — 62 раза
 * подряд), а часовой кэш витрин (`screenCache`) не мог записаться и после
 * перезагрузки всё качалось заново. Журналу пережить перезагрузку не нужно — он
 * для разбора «что ушло только что».
 *
 * Тело ответа хранится превью: целиком оно нужно редко, а страница РПН — это
 * 200 строк. Сырые данные при нужде смотрятся во вкладке Network браузера.
 */

const LEGACY_STORAGE_KEY = "network-logs";
const MAX_ENTRIES = 300;
/** Больше — вместо тела пишется размер: превью должно открываться, а не висеть. */
const MAX_BODY_CHARS = 20_000;

export interface NetworkLogEntry {
  id: string;
  timestamp: number;
  method: string;
  url: string;
  service: string;
  requestBody?: unknown;
  status: number | null;
  statusText?: string;
  responseBody?: unknown;
  duration: number;
  error?: string;
}

// Прежний журнал в `localStorage` — убрать один раз: он и занимал квоту.
try {
  localStorage.removeItem(LEGACY_STORAGE_KEY);
} catch {
  // приватный режим — нечего чистить
}

let entries: NetworkLogEntry[] = [];

function preview(body: unknown): unknown {
  if (body === undefined || body === null) return body;
  try {
    const text = JSON.stringify(body);
    if (text.length <= MAX_BODY_CHARS) return body;
    return `[ответ ${Math.round(text.length / 1024)} КБ — обрезан; целиком — во вкладке Network]`;
  } catch {
    return "[ответ не сериализуется]";
  }
}

export function logRequest(entry: NetworkLogEntry): void {
  entries = [
    { ...entry, requestBody: preview(entry.requestBody), responseBody: preview(entry.responseBody) },
    ...entries,
  ].slice(0, MAX_ENTRIES);
}

export function getLogs(): NetworkLogEntry[] {
  return entries;
}

export function clearLogs(): void {
  entries = [];
}

/* ─── Консоль ─── */

/**
 * Строка на каждый запрос: откуда пришёл ответ, сколько шёл, куда. Включено в
 * dev и по флагу `localStorage.sc_debug_api = '1'` на любом стенде — чтобы
 * посчитать запросы экрана на проде, не пересобирая его.
 */
export function apiDebugEnabled(): boolean {
  if (import.meta.env.DEV) return true;
  try {
    return localStorage.getItem("sc_debug_api") === "1";
  } catch {
    return false;
  }
}

export type ApiSource = "network" | "memory" | "storage" | "shared";

export function debugApi(source: ApiSource, method: string, url: string, ms?: number, status?: number | null): void {
  if (!apiDebugEnabled()) return;
  const label = { network: "сеть", memory: "кэш·память", storage: "кэш·хранилище", shared: "уже в пути" }[source];
  const tail = ms === undefined ? "" : ` ${ms} мс${status ? ` · ${status}` : ""}`;
  console.debug(`[api] ${label}${tail} ${method} ${url}`);
}
